import Request from '@/utils/request'

// 获取下单支付方式
export function apiFetchPayList(params) {
  return Request({
    url: '/api/v2/app/pay/channels',
    method: 'get',
    params,
  })
}

// 下单
export function apiFetchShopOrder(data) {
  return Request({
    url: '/api/v2/app/shop/order',
    method: 'post',
    data,
  })
}

// 获得金额列表
export function apiFetchBuyCoinsList(params) {
  return Request({
    url: '/api/v2/app/shop/5/goods',
    method: 'get',
    params,
  })
}

// 获取个人信息 头像 id
export function apiFetchUserInfo(params) {
  return Request({
    url: '/api/v2/app/prop',
    method: 'get',
    params,
  })
}

// My Invite 代理中心数据   //获取代理主播成员接口 tab 为 invite
export function apiFetchMyInvite(params) {
  return Request({
    url: '/api/v2/app/agent/host',
    method: 'get',
    params,
  })
}

// 获得月收益 income -> Hostess Performance
export function apiFetchMonthIncome(params) {
  return Request({
    url: '/api/v2/app/agent/host/month/income/page',
    method: 'get',
    params,
  })
}

// 获得代理周收益 income -> Hostess Performance
export function apiFetchWeekIncome(params) {
  return Request({
    url: '/api/v2/app/agent/host/week/income/page',
    method: 'get',
    params,
  })
}

// 获得日收益 income -> Hostess Performance
export function apiFetchDailyIncome(params) {
  return Request({
    url: '/api/v2/app/agent/host/daily/income/page',
    method: 'get',
    params,
  })
}

// 收益详情接口-invite-history
export function apiFetchInviteHistory(params) {
  return Request({
    url: '/api/v2/app/wallet/bill',
    method: 'get',
    params,
  })
}

// 提现页面数据
export function apiWithdrawPage(walletType, withdrawalMethod = '') {
  return Request({
    url: `/api/v2/app/withdraw/wallet/${walletType}/homepage?withdrawalMethod=${withdrawalMethod}`,
    method: 'get',
  })
}

// 获取提现方式接口
export function apiWithdrawMethod(params) {
  return Request({
    url: '/api/v2/app/withdraw/method',
    method: 'get',
    params,
  })
}

// 绑定提现账户
export function apiBindWithdrawAccount(data) {
  return Request({
    url: '/api/v2/app/withdraw/account/bind',
    method: 'post',
    data,
  })
}

// 修改提现账户
export function apiEditWithdrawAccount(data, cfgId) {
  return Request({
    url: `/api/v2/app/withdraw/account/cfg/${cfgId}`,
    method: 'put',
    data,
  })
}

// 获取用户提现账户
export function apiFetchWithdrawAccount(params) {
  return Request({
    url: '/api/v2/app/withdraw/account',
    method: 'get',
    params,
  })
}

// 申请提现
export function apiWithdrawApply(data, walletType) {
  return Request({
    url: `/api/v2/app/withdraw/wallet/${walletType}/apply`,
    method: 'post',
    data,
  })
}

// 提现申请查询接口
export function apiFetchWithdrawRecord(params) {
  return Request({
    url: '/api/v2/app/withdraw/apply',
    method: 'get',
    params,
  })
}

// 申请成为代理
export function apiAgentApply(data) {
  return Request({
    url: '/api/v2/app/agent/apply',
    method: 'post',
    data,
  })
}

// 获取用户信息
export function apiFetchUserAccountInfo(params) {
  return Request({
    url: '/api/v2/app/account/info',
    method: 'get',
    params,
  })
}

// 提现之前判断是否封禁
export function apiWithdrawVerify(data, walletType) {
  return Request({
    url: `/api/v2/app/withdraw/wallet/${walletType}/apply/check`,
    method: 'post',
    data,
  })
}

// 代理页面新增违规数据页面
export function apiFetchVioData(params) {
  return Request({
    url: '/api/v2/app/agent/host/punish/page',
    method: 'get',
    params,
  })
}

// 支付页面优惠劵列表-单参数
export function apiFetchCouponList(params) {
  return Request({
    url: '/api/v2/app/coupon',
    method: 'get',
    params,
  })
}

// 支付页面优惠劵列表-多参数
export function apiFetchMutiCouponList(params) {
  return Request({
    url: '/api/v2/app/coupon/v2',
    method: 'get',
    params,
  })
}

// my beans页面
export function apiFetchMyBeans(params) {
  return Request({
    url: '/api/v2/app/income/page',
    method: 'get',
    params,
  })
}

export function apiFetchMyBeansDetail(params) {
  return Request({
    url: '/api/v2/app/wallet/bill',
    method: 'get',
    params,
  })
}

export function apiFetchReport(weekDayTime) {
  return Request({
    url: `/api/v2/app/income/week/statistics?weekDayTime=${weekDayTime}`,
    method: 'get',
  })
}

export function apiFetchReportDetail(day) {
  return Request({
    url: `/api/v2/app/income/page/${day}/record`,
    method: 'get',
  })
}

// 主播中心
// 获取主播等级页面信息 /api/v2/app/host/grade/page
export function apiFetchHostGradeInfo(params) {
  return Request({
    url: '/api/v2/app/host/grade/page',
    method: 'get',
    params,
  })
}

// 获取主播违规信息
export function apiFetchPunishRecord(params) {
  return Request({
    url: '/api/v2/app/punish/record',
    method: 'get',
    params,
  })
}

// 获取违规统计
export function apiFetchPunishStatistics(params) {
  return Request({
    url: '/api/v2/app/punish/statistics',
    method: 'get',
    params,
  })
}

// 选择
export function apiFetchIncomeGradeList(params) {
  return Request({
    url: '/api/v2/app/host/grade/cfg',
    method: 'get',
    params,
  })
}
// 选择确定
export function apiFetchChoosePrivilege(grade) {
  return Request({
    url: `/api/v2/app/host/income/grade/${grade}`,
    method: 'post',
  })
}

// 主播任务列表
export function apiFetchHostessTaskPage(params) {
  return Request({
    url: '/api/v2/app/task/page',
    method: 'get',
    params,
  })
}

// 领取周奖励
export function apiFetchWeekTaskSubmit(week, weekTaskId) {
  return Request({
    url: `/api/v2/app/task/week/${week}/task/${weekTaskId}/submit`,
    method: 'get',
  })
}

// 领取每日任务
export function apiFetchAllRewardTask(taskId) {
  return Request({
    url: `/api/v2/app/task/${taskId}/submit`,
    method: 'post',
  })
}

// 哥伦比亚银行列表
export function apiGetColumbiaBankList() {
  return Request({
    url: '/api/v2/app/withdraw/1/bank/cfg',
    method: 'post',
    data: {},
  })
}

// 亲密度
export function apiIntimacyFriendship(targetUid) {
  return Request({
    url: `/api/v2/app/friend/relation/page/${targetUid}`,
    method: 'get',
  })
}

// 获取权益/送礼物
export function apiFriendshipGetAndSend(targetUid, grade, data) {
  return Request({
    url: `/api/v2/app/friend/claim/benefit/${targetUid}/${grade}`,
    method: 'post',
    data,
  })
}

// 删除亲密
export function apiDeleteFriendship(targetUid) {
  return Request({
    url: `/api/v2/app/friend/delete/${targetUid}`,
    method: 'post',
  })
}

// 签到-列表
export function apiSigninList() {
  return Request({
    url: '/api/v2/app/sign/host/first7day/mainPage',
    method: 'get',
  })
}

// 签到-提交签到
export function apiSubmitSignin() {
  return Request({
    url: '/api/v2/app/sign/host/first7day/sign',
    method: 'post',
  })
}

// 提现自动打款审核结果
export function apiWithdrawAutoCheckResult() {
  return Request({
    url: '/api/v2/app/withdraw/instant/pay/pre/check',
    method: 'post',
  })
}

// 提现打款状态
export function apiGetWithdrawStatus(withdrawId) {
  return Request({
    url: `/api/v2/app/withdraw/apply/${withdrawId}`,
    method: 'get',
  })
}

export function getAwsInfoApi() {
  return Request({
    url: '/api/v2/comm/aws/key',
    method: 'get',
  })
}

// 获取动态policy接口
export function apiGetDyPolicyApi(languageParam) {
  return Request({
    url: `/api/v2/app/agent/policy?languageParam=${languageParam}`,
    method: 'get',
  })
}

// 获取动态policy 预览接口
export function apiGetDyPolicyPreviewApi(languageParam) {
  return Request({
    url: `/api/v2/app/agent/policy/preview?languageParam=${languageParam}`,
    method: 'get',
  })
}

// 主播排行榜-领取
export function apiGetHostessRankApi(params) {
  return Request({
    url: '/api/v2/app/rank/onDemand/rankPage',
    method: 'get',
    params,
  })
}

// 主播排行榜-配置
export function apiGetHostessRankCfgApi() {
  return Request({
    url: '/api/v2/app/rank/onDemand/rewardCfg',
    method: 'get',
  })
}

// 主播排行榜-领取
export function apiGetHostessRankGetApi() {
  return Request({
    url: '/api/v2/app/rank/onDemand/getReward',
    method: 'get',
  })
}

export function getPackageNamePayBack(params) {
  return Request({
    url: '/api/v2/app/pay/redirect',
    method: 'get',
    params,
  })
}

export function getBanner() {
  return Request({
    url: '/api/v2/app/banner/propPage',
    method: 'get',
  })
}

export function getUserProps(params) {
  return Request({
    url: '/api/v2/app/prop/v2',
    method: 'get',
    params,
  })
}

export function getUserFrames() {
  return Request({
    url: '/api/v2/app/prop/10/decorate',
    method: 'get',
  })
}

export function equipFrame(propType, propId) {
  return Request({
    url: `/api/v2/app/prop/${propType}/${propId}/decorate`,
    method: 'post',
  })
}

export function unequipFrame(propType, propId) {
  return Request({
    url: `/api/v2/app/prop/${propType}/${propId}/decorate`,
    method: 'delete',
  })
}

export function exchangeFrame(propType, propId) {
  return Request({
    url: `/api/v2/app/prop/${propType}/${propId}/exchange`,
    method: 'post',
  })
}

export function getCouponInfo() {
  return Request({
    url: '/api/v2/app/coupon/page',
    method: 'get',
  })
}

export function getCouponList(params) {
  return Request({
    url: '/api/v2/app/coupon',
    method: 'get',
    params,
  })
}

export function getPropInfo(propType) {
  return Request({
    url: `/api/v2/app/prop/${propType}/v2`,
    method: 'get',
  })
}

// 男用户等级页面
export function getUserLevelInfo() {
  return Request({
    url: '/api/v2/app/account/male/grade/detail',
    method: 'get',
  })
}

export function getBaseInfo() {
  return Request({
    url: '/api/v2/web/base/Info',
    method: 'get',
  })
}

export function getMaleSigninData() {
  return Request({
    url: '/api/v2/app/sign',
    method: 'get',
  })
}

export function getMaleTasksData() {
  return Request({
    url: '/api/v2/app/task/male/page',
    method: 'get',
  })
}

export function maleTaskSignin() {
  return Request({
    url: '/api/v2/app/sign',
    method: 'post',
  })
}

export function maleTaskClaim(taskId, conditionId) {
  return Request({
    url: `/api/v2/app/task/male/${taskId}/condition/${conditionId}/submit`,
    method: 'post',
  })
}

export function maleTaskRemind(status) {
  return Request({
    url: `/api/v2/app/sign/remind/${status}`,
    method: 'post',
  })
}

export function hostessIncomeRank(dateType, constType) {
  return Request({
    url: `/api/v2/app/rank/${dateType}/time/${constType}`,
    method: 'get',
  })
}
